/* unplugin-vue-components disabled */import script from "./Stadium.vue?vue&type=script&lang=ts&setup=true"
export * from "./Stadium.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__